/* eslint-disable import/no-anonymous-default-export */
export default {
	styleOverrides: {
		root: {
			padding: 0,
			maxWidth: '70% !important',
		},
	},
};
